import { useState, useRef, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBModalFooter, MDBSelect, MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import linkicon from "../../../components/images/link.svg";
import remove1 from "../../../components/images/remove.svg";
import { GetTemplate } from "./AutoDeviceButtonTeamplates";
import { useAutoDeviceButtonContext } from "./AutoDeviceButtonContext";
import dragAndDrop from "../../../components/images/Send_Receive.svg";
import PopupLoader from "../../../views/popups/PopupLoader";

export function LoadBLFGroupsTemplate(props) {
  const buttonNo = props.buttonNo;
  const buttonInfo = props.buttonInfo;
  const autoDeviceContext = useAutoDeviceButtonContext();
  const {
    buttonTypes,
    ringTypes,
    removeFun,
    blfgroupsInfo,
    addBlf,
    togleAlert,
    updateFun,
    setRingTypeDefualt,
    defualtRing
  } = autoDeviceContext;

  const {
    control,
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext(); // Accessing form context

  const { t, i18n } = useTranslation();
  const [button, setButton] = useState(buttonTypes);
  const [buttonChange, setButtonChange] = useState(
    buttonInfo.button_type ? buttonInfo.button_type * 1 : 2
    
  );
  const [prevringType, prevSetRingType] = useState(buttonInfo?.ring_type * 1);
  const [selectedGroup, setSelectedGroup] = useState(
    buttonInfo.blf_group_id ? buttonInfo.blf_group_id * 1 : 2
  );
  const [ringType, setRingType] = useState(defualtRing);

  const [lineValueName, setLineValueName] = useState(
    buttonInfo?.user_value_name
  );
  const [list, setList] = useState([]);
  const [blflist, setBlfList] = useState([]);
  const prevSelectedGroup = useRef(
    buttonInfo.blf_group_id ? buttonInfo.blf_group_id * 1 : 2
  );

  const [groupError, setGroupError] = useState(false);
  const [grpInfo, setGrpInfo] = useState({});
  //const [length, setLength] = useState(0);
  let length = props.fields.filter(
    (field, index) => field.blf_group_id === buttonInfo.blf_group_id
  ).length;

  // setLength(len);
  useEffect(() => {
    const blfFields = props.fields.filter(
      (field, index) => field.blf_group_id === buttonInfo.blf_group_id
    )
    console.log("BLF Fiels in useEffect : " + JSON.stringify(blfFields));
    setList(blfFields);
  }, []);

  const handleRingChange = (item, onChange,value) => {
    if (!item) return;
      if (!item || item.value === value) return; // ignore if value hasn't changed
    // if (ringType == item.value) return;
    let lineData = getValues("dataList")[props.index]
    const allBlfFields = props.fields.filter((field)=>field.button_type == 3 || field.button_type == 10)
    setRingType(`dataList.${props.index}.ring_type`);
    // updateFun(props.index,{...lineData,ring_type_change:prevringType});
    allBlfFields.map((field) => {
      updateFun(field.index, {
        ...field,
        ring_type : item.value,
        ring_type_change : prevringType,
        isNewBLF:true
      });
    });
    setRingTypeDefualt(item.value)
    onChange(item.value); 
  };

 const handleLabelChange = (index, value) => {
  // label update
  setValue(`dataList.${index}.label`, value,{shouldDirty:true});

  //  ONLY EXTRA KEY
  setValue(`dataList.${index}.isLabelEdited`, true);
};

  const checkIsBlfToBlf = (idx) => {
    console.log("checkIsBlfToBlf");
    var dataList = getValues("dataList");
    if (dataList && dataList[idx]?.blf_group_id > 0) {
      let users = dataList.filter(
        (item) => item.blf_group_id == dataList[idx]?.blf_group_id
      );
      console.log("[BLFgroup-BLFgroup]Already Exist BlfGroupusers :" + users);
      return true;
    } else {
      console.log("change is not [BLFgroup-BLFgroup]");
      let data = {
        type: "popup",
        title: "updateBLFGroup",
        text: "updateBLFGrouptxt",
        button: "okay",
        // content: (
        //   <div className="modal-footer">
        //     {t("updateBLFGrouptxt")}
        //     <button type="button" className="btn green-button">
        //       {t("okay")}
        //     </button>
        //   </div>
        // ),
      };
      togleAlert(data);
      return false;
    }
  };

  const removeDuplicateUsers = (dataList, group, index) => {
    console.log("[removeDuplicateUsers] :");
    let filteredBlfGroup = [];
    group.forEach((grp) => {
      let user = dataList.filter((data) => {
        if (
          data.blf_group_id &&
          data.blf_group_id !== dataList[index].blf_group_id
        ) {
          return grp.user_or_value === data.user_or_value * 1;
        }
      });
      console.log("user :", user);
      if (user && user.length == 0) {
        filteredBlfGroup.push(grp);
      }
    });
    return filteredBlfGroup;
  };

  /**
   * it removes BLF Group objects and add Empty objects to current position
   * Logic works for Delete or remove [X] from UI Action
   * Logic works for Swithching from BLFgroup to other templetes like park,speedDail,BLF,BLA,BLank...etc
   * @param {*} index
   * @returns
   */

  const removeBLF = (index) => {
    removeFun(index);
  };

  //console.log("errors are : ");
  //console.log({ errors });

  const bLF_Error_Checking = (insertBlfgroup, positionIndex) => {
    console.log("[bLF_Error_Checking] positionIndex :" + positionIndex);

    console.log(
      "DataList object ofr current index  :" +
      JSON.stringify(getValues("dataList")[positionIndex])
    );

    const existGroup = getValues("dataList")[positionIndex].blf_group_id;
    console.log("existGroup id :" + existGroup);

    let configured_Lines = getValues("dataList").filter((item, index) => {
      if (index >= positionIndex) {
        //not require >= becaus we are doing again -1
        console.log("item: " + index + " idx: " + index);
        if (item.button_type == 10 && item.blf_group_id == existGroup) {
          return false;
        } else if (item.button_type !== 6) {
          return item.button_type !== 6;
        }
      }
    });

    console.log("configured_Lines :" + JSON.stringify(configured_Lines));

    configured_Lines = configured_Lines.length;

    const total_phoneButtons = getValues("dataList").length;
    const startButton = positionIndex + 1;

    /* Max Number of Usable Buttons = [Total Phone Buttons - (Start Button -1)]; 14-(4-1) = 11 */
    const max_no_usableBtns = total_phoneButtons - (startButton - 1);

    /*Buttons Required = [BLF Group Buttons + Configured Lines]; 6+2 = 8 */
    const required_buttons = insertBlfgroup.length + configured_Lines;

    console.log(
      "configured_Lines :" +
      configured_Lines +
      " ,total_phoneButtons :" +
      total_phoneButtons +
      " ,startButton :" +
      startButton +
      " ,max_no_usableBtns: " +
      max_no_usableBtns +
      " ,required_buttons :" +
      required_buttons
    );

    /*As Long as Buttons Required <= Max Number of Usable Buttons there is no error, so 8 <= 11 we are good!*/

    if (required_buttons <= max_no_usableBtns) {
      console.log("[bLF_Error_Checking] we are good! No errors");
      return false;
    } else {
      console.log(
        "Updating blf group doesnt have suffiecient buttons in phone"
      );
      return true;
    }
  };

  const handleButtonChange = (item) => {
    console.log(
      "[BlfGroupTemplete] handleButtonChange :" + JSON.stringify(item)
    );

    if (item.type == "button") {
      removeBLF(props.index);

      setValue(`dataList.${props.index}.button_type`, parseInt(item.value));

      setButtonChange(item.value);
    } else {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);
      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        return;
      }


      if (bLF_Error_Checking(blfgroupsInfo[item?.value], props.index)) {
        let data = {
          type: "popup",
          title: "updateBLFGroup",
          text: "updateBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      props.buttonInfo.blf_group_id = item.value;

      setSelectedGroup(item.value);

      console.log("blfgroupsInfo :" + JSON.stringify(blfgroupsInfo));

      if (checkIsBlfToBlf(props.index)) {
        removeBLF(props.index);
      }

      if (blfgroupsInfo && blfgroupsInfo[item.value]) {
        let blfGroupToInsert = removeDuplicateUsers(
          getValues("dataList"),
          blfgroupsInfo[item.value],
          props.index
        );
        addBlf(props.index, blfGroupToInsert);
        //insertFun(props.index, blfgroupsInfo[item.value]);
      }
    }

    console.log(
      "setting blf_group_id value to in LoadBLFTemplate: " + item.value
    );
  };

  return (
    <>
      {buttonChange == 10 && (
        <>
          <tr
            className="dragItem"
            key={props.id}
            ref={props.provided.innerRef}
            {...props.provided.draggableProps}
            {...props.provided.dragHandleProps}
            style={props.style}
          >
            <td key={props.id} colSpan="7" className="w-100 p-0 ">
              <table
                key={props.id}
                className="datatable table-responsive mt-0 table2 w-100 p-0"
              >
                {list.map((item, index) => {
                  return (
                    <>
                      <tr
                        key={item.id}
                        className={
                          props.buttonInfo.blf_error * 1 == 0
                            ? "table2"
                            : "table2 bg-danger  bg-opacity-50"
                        }
                      >
                        <td className="w-5">
                          <img
                            className={`link-icon pe-1 pb-1 ${index != 0 ? "ms-4" : ""}`}
                            src={index != 0 ? linkicon : dragAndDrop}
                            alt="Remove"
                          />
                          <input
                            type="hidden"
                            {...register(`dataList.${item.index}.button_no`)}
                            value={item.button_no}
                          />
                          {item.index + 1}
                        </td>

                        <td>
                          {index == 0 && (
                            <>
                              <div className="d-flex">
                                <div className="phoneselect bg-light">
                                  <MDBSelect
                                    onChange={(e) => {
                                      if (e && selectedGroup != e?.value) {
                                        handleButtonChange(e);
                                      }
                                    }}
                                    className="w-200px"
                                    data={buttonTypes}
                                    value={selectedGroup}
                                  />
                                </div>
                              </div>
                              <div>
                                {groupError && <p className="text-danger w-200px text-small">
                                  <b className="text-danger">{grpInfo.text}</b> already assigned to a button.
                                </p>}
                              </div>
                            </>
                          )}
                        </td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect">
                              <input
                                className="w-200px"
                                type="text"
                                {...register(
                                  `dataList.${item.index}.user_value_name`
                                )}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect bg-light">
                              <input
                                type="text"
                                className="selectname-small"
                                defaultValue={item.label}
                                onChange={(e) =>
                                  handleLabelChange(item.index, e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect bg-light">
                              <Controller
                                name={`dataList.${item.index}.ring_type`}
                                control={control}
                                shouldUnregister={true}
                                defaultValue={defualtRing}
                                rules={{ required: true }}
                                render={({
                                  field: { onChange, onBlur, value, ref },
                                }) => (
                                  <MDBSelect
                                    className="bg-white "
                                    onChange={(item) => handleRingChange(item,onChange,value)}
                                    data={ringTypes}
                                    default={defualtRing}
                                    value={value}
                                    disabled={index !== 0}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </td>
                        {index == 0 && (
                          <td className="cursor-pointer"
                            onClick={(e) => {
                              removeFun(item.index);
                            }}
                          >
                            <MDBIcon color="primary" fas icon="times" />
                            {/* <img
                              className="close-icon ms-2"
                              src={remove1}
                              alt="Remove"
                            /> */}
                          </td>
                        )}
                        {index != 0 && <td></td>}
                      </tr>
                    </>
                  );
                })}
              </table>
            </td>
          </tr>
        </>
      )}

      {buttonChange < 10 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
}
